// Global packages and components
import { Image } from '~/components'

// Types
import type { SanityLinkObject, SanityRefWithAlt } from '~/types'

interface Props {
  columns: {
    image: SanityRefWithAlt
    link: SanityLinkObject
  }[]
}

// Main export
export default function BlockBannerStrips({ columns }: Props) {
  return (
    <div className="container grid grid-cols-1 gap-6 md:grid-cols-3 lg:gap-8 xl:gap-10">
      {columns?.map((e, i) => (
        <div
          key={i}
          className="relative aspect-[5/2] overflow-hidden rounded-xl"
        >
          {e?.image?.asset && (
            <Image
              image={e.image}
              customSize={768}
              className="absolute left-0 top-0 size-full object-cover"
            />
          )}
        </div>
      ))}
    </div>
  )
}
